// extracted by mini-css-extract-plugin
module.exports = {"supportHeader":"SupportHeader_supportHeader__ImPMc","desktopSliderImage":"SupportHeader_desktopSliderImage__zMMj8"};